export const blogBoxSlider = (instance, options) => {
    return {
        loop: false,
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 50,
        cssMode: true,
        breakpoints: {
            1024: {
                cssMode: false,
                spaceBetween: 24,
                slidesPerView: 2,
                slidesPerGroup: 2
            }
        },
    }
}